<template>
  <transition name="show">
    <div class="rest-list-wrapper flex flex-col" >
      <div class="trlistwrapper" ref="rest_list" v-if="restaurant_data && !refresh">
        <div class="trlistitem" v-for="(item, index) in displayList" :key="index">

          <item-grid-view :item="item" :detail="cartButtonClicked" :ref="'restaurant'.concat(index)">
            <!-- SLOT: ACTION BUTTONS -->
            <template slot="action-buttons">
              <div class="flex flex-wrap">
                <!-- SECONDARY BUTTON: ADD-TO/VIEW-IN CART -->
                <div
                  class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                  @click="cartButtonClicked(item)">
                  <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4" />

                  <span class="text-sm font-semibold ml-2">VIEW</span>
                </div>
              </div>
            </template>
          </item-grid-view>

        </div>
        <div class="alert__container" v-if="!restaurant_data.data">
          <div class="alert alert__warning" role="alert">
            <feather-icon icon="AlertTriangleIcon" class="warning" svgClasses="h-5 w-5" />
            <p class="alert__text">There are no open restaurants right now. Please check back later</p>
          </div>
        </div>
      </div>

      <div class="pagination" v-if="maxItems > itemCount">

        <div @click="pageFirst" class="no-border"><i class="fas fa-angle-double-left"></i></div>
        <div @click="pageDown" class="no-border"><i class="fas fa-angle-left"></i></div>
        <div class="cursor-pointer" @click="paginate_click(page, index)" v-for="(page, index) in split_pagination" :key="index" :class="page === pageCount + 1 ? 'active' : ''">{{page}}</div>
        <div @click="pageUp" class="no-border"><i class="fas fa-angle-right"></i></div>
        <div @click="pageLast" class="no-border"><i class="fas fa-angle-double-right"></i></div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'CateringTabsAll',
  beforeMount () {
    this.areaRestaurants = false
    this.getRestaurantList()
  },
  data () {
    return {
      restaurant_data: null,
      closed_restaurant_data: null,
      image_height: 0,
      image_width: 0,
      location: null,
      gettingLocation: false,
      errorStr: null,
      areaRestaurants: null,
      geocoder: null,
      pageCount: 0,
      maxItems: 0,
      refresh: false
    }
  },
  watch: {
    refresh () {
      if (this.refresh) {
        const self = this
        setTimeout(() => {
          self.refresh = false
        }, 0)
        //self.$refs.rest_list.scrollIntoView({ behavior: 'smooth' })
      }
    },
    pageCount () {
      this.getRestaurantList()
    }
  },
  components: {
    ItemGridView: () => import('../../restaurantlist/components/ItemGridView.vue'),
    ItemListView: () => import('../../restaurantlist/components/ItemListView.vue')
  },
  computed: {
    itemCount () {
      if (this.isMobile)  {
        return 8
      } else {
        return 9
      }
    },
    isMobile () { return this.$store.state.api.isMobile },
    displayList () {
      const array = JSON.parse(JSON.stringify(this.all_restaurants))
      /*if (this.sort_by_date) {
        array = array.sort((a, b) => {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.created_date) - new Date(a.created_date)
        })
      }*/
      return array
    },
    pageArray () {
      //const array = JSON.parse(JSON.stringify(this.all_restaurants))
      const page_array = []
      let i = 0
      const max_page = Math.floor(this.maxItems / this.itemCount)
      for (i = 0; i < max_page; i++) {
        page_array.push(parseInt(i) + 1)
      }
      const kalan = Math.floor(this.maxItems % this.itemCount)
      if (kalan > 0) {
        page_array.push(max_page + 1)
      }
      return page_array
    },
    split_pagination () {
      const arr = this.pageArray
      const result = []
      if (arr.length > 5) {
        if (this.pageCount < arr.length - 2 && this.pageCount > 1) {
          result.push('...')
          result.push(this.pageCount)
          result.push(this.pageCount + 1)
          result.push(this.pageCount + 2)
          result.push('...')
          //result.push(arr.length)
        } else if (this.pageCount < 3) {
          result.push(arr[0])
          result.push(arr[1])
          result.push(arr[2])
          result.push('...')
          result.push(arr.length)
        } else {
          result.push(arr[0])
          result.push('...')
          result.push(arr.length - 2)
          result.push(arr.length - 1)
          result.push(arr.length)
        }
        return result
      } else {
        return arr
      }
    },
    all_restaurants () {
      return this.restaurant_data.data
    },
    restaurantlist () {
      return this.$store.state.api.restaurantlistall
    },
    deliveryAddress () {
      return this.$store.state.api.deliveryAddress
    }
  },
  methods: {
    pageDoubleUp () {
      if (this.pageCount < this.pageArray.length - 3) {
        this.pageCount += 3
      }
    },
    pageFirst () {
      this.pageCount = 0
    },
    pageLast () {
      this.pageCount = this.pageArray.length - 1
    },
    pageDoubleDown () {
      if (this.pageCount !== 0 && this.pageCount !== 1) {
        this.pageCount -= 3
      }
    },
    pageUp () {
      if (this.pageCount < this.pageArray.length - 1) {
        this.pageCount += 1
      }
    },
    pageDown () {
      if (this.pageCount !== 0) {
        this.pageCount -= 1
      }
    },
    async locationToShow () {
      const isLoggedIn = await this.$store.state.api.isUserLoggedIn()
      if (isLoggedIn) {

        if (this.deliveryAddress.id !== 0) {
          const address_str = `${this.deliveryAddress.address} ${this.deliveryAddress.city} ${this.deliveryAddress.region} ${this.deliveryAddress.post_code}`
          this.getAddressLocation(address_str, (result) => {
            this.location = [result[0].geometry.location.lat(), result[0].geometry.location.lng()] //[customer_loc.coords.latitude, customer_loc.coords.longitude]
            this.getHomeRestaurantList()
          })
        } else {

          const customer_loc = await this.getLocation()
          this.areaRestaurants = false
          try {
            this.gettingLocation = false
            this.location = [customer_loc.coords.latitude, customer_loc.coords.longitude]
            this.areaRestaurants = true
            this.getHomeRestaurantList()
          } catch (e) {
            this.gettingLocation = false
            this.errorStr = e.message
            this.areaRestaurants = false
            this.getRestaurantList()
            this.getClosedRestaurantList()
          }
        }
      } else {
        const customer_loc = await this.getLocation()

        try {
          this.gettingLocation = false
          this.location = [customer_loc.coords.latitude, customer_loc.coords.longitude] //
          this.areaRestaurants = true
          this.getHomeRestaurantList()
        } catch (e) {
          this.gettingLocation = false
          this.errorStr = e.message
          this.areaRestaurants = false
          this.getRestaurantList()
          this.getClosedRestaurantList()
        }
      }
    },
    async getLocation () {

      return new Promise((resolve, reject) => {
        if (!('geolocation' in navigator)) {
          reject(new Error('Geolocation is not available.'))
        }

        navigator.geolocation.getCurrentPosition(pos => {
          resolve(pos)
        }, err => {
          reject(err)
        })

      })
    },
    paginate_click (page, index) {
      if (page === '...') {
        if (index === this.split_pagination.length - 2 || index === this.split_pagination.length - 1) {
          this.pageDoubleUp()
        } else {
          this.pageDoubleDown()
        }
      } else {
        this.pageCount = page - 1
      }
    },
    cartButtonClicked (item) {
      this.$router.push({
        name: 'restaurant-products',
        params: {
          restaurant_id: String(item.user_property['Alias']),
          related_items: this.restaurantlist
        }})
    },
    getRestaurantList () {

      this.$vs.loading()

      const payload = {
        page: this.pageCount + 1,
        limit: this.itemCount
      }

      this.$store.dispatch('api/getCateringRestaurantList', payload)
        .then((response) => {
          this.$vs.loading.close()
          this.restaurant_data = response.data
          this.maxItems = this.restaurant_data.total
          this.refresh = true
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    },
    getClosedRestaurantList () {

      this.$vs.loading()

      const payload = {
        page: 1,
        limit: 20,
        filterOpen: 0
      }

      this.$store.dispatch('api/getClosedRestaurantList', payload)
        .then((response) => {
          this.$vs.loading.close()
          this.closed_restaurant_data = response.data
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    },
    getHomeRestaurantList () {
      this.$vs.loading()
      const payload = {
        lat: this.location[0],
        lng: this.location[1]
      }

      this.$store.dispatch('api/getHomeRestaurantList', payload)
        .then((response) => {
          this.$vs.loading.close()
          this.restaurant_data = response.data
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    getAddressLocation (address_text, callback) {
      const addressObj = {
        address: address_text,
        country: 'United States'
      }
      this.geocoder.geocode(addressObj, (response, status) => {
        if (status === window.google.maps.GeocoderStatus.OK) {
          callback(response)
        }
      })
    }
  }
}
</script>
<style lang="scss">
</style>
